// RTK Query tag types and IDs for strategy API
export const TERRITORY_TAG_TYPES = {
  TERRITORY: 'Territory',
} as const;

export const TERRITORY_TAG_IDS = {
  ALL_TERRITORIES: 'ALL_TERRITORIES',
  USER_TERRITORIES: 'USER_TERRITORIES',
} as const;

// Export individual constants for easier use with 'as const'
export const TERRITORY_TAG_TYPE = 'Territory' as const;
// Refinement version history — invalidated on refinement commit / version delete
export const OPTIMIZATION_VERSION_TAG_TYPE = 'OptimizationVersion' as const;
export const ALL_TERRITORIES_ID = 'ALL_TERRITORIES' as const;
export const USER_TERRITORIES_ID = 'USER_TERRITORIES' as const;
